import { FC, lazy, Suspense } from 'react';

const DTicketExistLazy = lazy(() => import('./source/DTicketExist'));

export const DTicketExist: FC = () => (
	<Suspense fallback={null}>
		<DTicketExistLazy />
	</Suspense>
);
